import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Portfolio from "./components/portfolio/Portfolio";
import CaseStudy from "./components/portfolio/CaseStudy";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Portfolio />} />
                    <Route path="/work/:slug" element={<CaseStudy />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
